import PropTypes from 'prop-types'

import { SHOW_ALTERNATE_COURSES } from '@/utils/constants'

function CertificateRequirements({ certificate }) {
  return (
    <div>
      {certificate.courseRequirements?.length > 0 ? (
        <ul className="">
          {certificate.courseRequirements.map((req) => {
            const hasAlternate =
              SHOW_ALTERNATE_COURSES && req.alternativeCourses && req.alternativeCourses.length > 0

            return (
              <li key={req.id} className="text-sm">
                {req.primaryCourse.name}{' '}
                {hasAlternate && (
                  <span>| {req.alternativeCourses.map((c) => c.name).join(' | ')}</span>
                )}
              </li>
            )
          })}
        </ul>
      ) : (
        <span className="text-muted-foreground">No requirements</span>
      )}
    </div>
  )
}
CertificateRequirements.propTypes = {
  certificate: PropTypes.object.isRequired,
}

export default CertificateRequirements
